export default __webpack_public_path__ + "static/media/black-site-icon.15429d88.svg";